import BaseAPI from '../api'

export interface LogInterface {
    idDepartment?: number
    idRole?: number
    endDate?: string;
    startDate?: string;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
}

export default class LogApi extends BaseAPI {

    static getRequestLog(props: LogInterface): Promise<any> {
        return this.api.get(`request-logs`, { params: { ...props } })
            .then((res) => res)
    }
    static getRequestLogDownload(props: LogInterface): Promise<any> {
        return this.api.get(`request-logs/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }
    static getDocumentLogs(props: LogInterface): Promise<any> {
        return this.api.get(`document-logs`, { params: { ...props } })
            .then((res) => res)
    }
    static getDocumentLogsDownload(props: LogInterface): Promise<any> {
        return this.api.get(`document-logs/download`, { params: { ...props }, responseType: 'arraybuffer' })
            .then((res) => res)
    }
    static getDocumentLogsRefCode(refCode: string, props: LogInterface): Promise<any> {
        return this.api.get(`document-logs/${refCode}`, { params: { ...props } })
            .then((res) => res)
    }
}